import { GET_GLOBALCONFIG } from '../mutation-types';

const state = {
  data: null
};

const getters = {
  // eslint-disable-next-line no-shadow 
  GLOBAL_DATA: state => state.data
};

const mutations = {
  // eslint-disable-next-line no-shadow
  [GET_GLOBALCONFIG]: (state, payload) => {
    state.data = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  [GET_GLOBALCONFIG]: async (context, payload) => {
    const { data } = await Ajax.get('/api/config/getGlobalConfig');
    context.commit(GET_GLOBALCONFIG, data);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/global.js